import { Injectable } from '@angular/core';
import { BonusStatus } from '@my-account/const';
import { MyAccountActions, MyAccountSelectors, StateWithMyAccount } from '@my-account/data-access';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BonusStatusService {
  constructor(private store: Store<StateWithMyAccount>) {}

  loadBonusStatus(): void {
    this.store.dispatch(new MyAccountActions.LoadBonusStatus());
  }

  getBonusStatus(): Observable<BonusStatus> {
    return this.store.select(MyAccountSelectors.getBonusStatusValue);
  }
}
